import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  InputError = '[STORE | CONTROL | ERROR] Input Error'
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Input Error
 */
export class InputError {
  public static readonly type = ActionTypes.InputError;

  public constructor(public error: FlatModels.ErrorControlModels.MedsurfInputError) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>
